<template>
    <div>
        <div ref="videoList" class="video-list">

          <h1>Filmdokumente</h1>
          <h3>Charlotte Kerr: <i>Friedrich Dürrenmatt. Portrait eines Planeten</i> (1984)</h3>
          <ol >
            <li>Die Entdeckung des Humors – der Künstler als zweiter Gott</li>
            <li>Die Anlage zur künstlichen Besamung von Rindern</li>
            <li>Die Welt als Labyrinth und Irrenhaus</li>
            <li>Kindheit: Das Zeichnen im Dorf, erste schriftstellerische Ansätze, die griechischen Sagen</li>
            <li>Kindheit: Sterne und weitere Motive; der Konolfingen-Plan</li>
            <li>In der Jugend von einem Hund angefallen </li>
            <li>Von der Malerei zur Schriftstellerei</li>
            <li>Philosophiestudium und Explosion im Drama</li>
            <li>Die Entscheidung für die Schriftstellerei (Trolleybus-Szene)</li>
            <li>Mündliche und schriftliche Sprache</li>
            <li>Das Handwerk des Schreibens</li>
            <li>Das Scheitern am <i>Turmbau</i>-Drama</li>
            <li>Malerfreund Varlin, sein Tod</li>
            <li>Entstehung des <i>Besuchs der alten Dame</i> und plötzlicher Reichtum</li>
            <li>Lesung <i>Die Brücke</i></li>
            <li>Lieblingsszene in <i>Frank V</i>.</li>
            <li>F.D. erzählt <i>Der Tod des Sokrates</i></li>
            <li>Das Scheitern wagen</li>
            
          </ol>
          <!--<h1>Seminar Los Angeles zu Johanna die Wahnsinnige</h1>
          <ul>
            <li></li>
          </ul>-->
        </div>
    </div>
</template>

<script>


export default {
    name: "VideoList"

}
</script>

<style lang="scss" >
.video-list {
  display: block;
  max-width: 600px;
  margin: 150px auto;
ol {
    display: block;
    list-style-position: outside;
    list-style-type: decimal;
    text-align: left;
    li {
      
      padding: 5px 0;      
      text-align: left;
      font-size: 1.3rem;
    }
  }
}

</style>